import {resetCertificateValue} from "../../certificate";
import {postData} from "../../utils/common";
import {AnswerType} from "../../utils/consts";
import {commonEventEmitter} from "../../commonEventEmitter";

const post = ({form, state, submitButton}) => {
  const answerElement = form.querySelector(`.js-answer`);
  const inputsContainer = state.isApplication ? form.querySelector(`.js-form-inputs-container`) : null;
  const headContainer = state.isApplication ? form.querySelector(`.js-form-head`) : null;
  const submitButtonTextElement = submitButton.querySelector(`.js-button-text`);
  const answerConfirmButtonElements = answerElement.querySelectorAll(`.js-answer-confirm`);
  const loaderElement = answerElement.querySelector(`.js-preloader`);
  let isHtmlContent;

  const onCaptchaRemove = () => {
    state.captcha.token = null;
  };

  const onCaptchaGet = (token, type) => {
    state.captcha.token = token ? token : null;

    if (type === state.captcha.type && state.isActive) {
      post();
    }
  };

  const getDefaultButtonText = () => {
    if (submitButtonTextElement.innerHtml) {
      isHtmlContent = true;
      return submitButtonTextElement.innerHtml;
    }

    return submitButtonTextElement.textContent;
  };

  const DEFAULT_BUTTON_TEXT = getDefaultButtonText();

  const hideApplicationContainers = () => {
    if (state.isApplication) {
      inputsContainer.classList.add(`application__labels--hidden`);
      headContainer.classList.add(`application__head--hidden`);
    }
  };

  const addButtonsEventListener = (eventHandler) => {
    answerConfirmButtonElements.forEach((buttonElement) => buttonElement.addEventListener(`click`, eventHandler));
  };

  const removeButtonsEventListener = (eventHandler) => {
    answerConfirmButtonElements.forEach((buttonElement) => buttonElement.removeEventListener(`click`, eventHandler));
  };

  const hideAnswer = (answerType, textElement, eventCB) => {
    answerElement.classList.remove(`show`);
    textElement.classList.remove(`show`);
    submitButton.classList.remove(`button--error`);
    submitButton.classList.remove(`button--success`);

    if (isHtmlContent) {
      submitButtonTextElement.innerHtml = DEFAULT_BUTTON_TEXT;
    } else {
      submitButtonTextElement.textContent = DEFAULT_BUTTON_TEXT;
    }

    if (state.isApplication) {
      inputsContainer.classList.remove(`application__labels--hidden`);
      headContainer.classList.remove(`application__head--hidden`);
    }

    state.isActive = true;

    if (answerType === AnswerType.SUCCESS) {
      form.reset();
      form.querySelectorAll(`.js-files`).forEach((element) => element.remove());
      form.querySelectorAll(`.js-required`).forEach((element) => element.classList.remove(`fill`));
      form.querySelector(`.js-submit`).classList.add(`disabled`);
      state.isActive = false;

      if (state.isCertificate) {
        resetCertificateValue();
      }
    }

    if (state.isCertificate) {
      removeButtonsEventListener(eventCB);
    }
  };

  const enableAnswer = (answerType) => {
    state.isActive = false;

    const onConfirmButtonClick = () => hideAnswer(answerType, textElement, onConfirmButtonClick);

    let textElement;

    submitButton.classList.remove(`button--sended`);

    switch (answerType) {
      case AnswerType.SUCCESS:
        hideApplicationContainers();
        textElement = answerElement.querySelector(`.js-succes`);
        submitButton.classList.add(`button--success`);
        submitButtonTextElement.textContent = `Готово`;
        break;
      case AnswerType.FAIL:
        hideApplicationContainers();
        textElement = answerElement.querySelector(`.js-fail`);
        submitButton.classList.add(`button--error`);
        submitButtonTextElement.textContent = `Ошибка`;
        break;
    }

    if (loaderElement) {
      loaderElement.classList.add(`hide`);
    }
    textElement.classList.add(`show`);

    if (state.isCertificate) {
      addButtonsEventListener(onConfirmButtonClick);
    } else {
      if (!state.confirmReset) {
        addHideAnswerTimer(answerType, textElement);
      } else {
        if (answerType === AnswerType.SUCCESS) {
          submitButton.addEventListener(`click`, onSubmitButtonClick);
        } else if (answerType === AnswerType.FAIL) {
          addHideAnswerTimer(answerType, textElement);
        }
      }
    }
  };

  const addHideAnswerTimer = (answerType, textElement) => {
    const timerId = setTimeout(() => {
      clearTimeout(timerId);

      hideAnswer(answerType, textElement);
    }, 3000);
  };

  const post = () => {
    if (state.enabledCaptcha && !state.captcha.token) {
      if (!window.smartCaptcha) {
        return;
      }

      commonEventEmitter.emit(`captcha.set-type`, state.captcha.type);
      window.smartCaptcha.execute();
      return;
    }

    if (state.isActive) {
      answerElement.classList.add(`show`);
      submitButtonTextElement.textContent = `Отправляем`;
      submitButton.classList.add(`button--sended`);
      const formData = new FormData(form);
      if (state.files.length) {
        addFilesFormData(state.files, formData);
      }

      if (state.enabledCaptcha && state.captcha.token) {
        formData.set(`smart-token`, state.captcha.token);
      }

      postData(formData, state.url)
      .then((data) => {
        if (data === 200) {
          enableAnswer(AnswerType.SUCCESS);
        } else {
          enableAnswer(AnswerType.FAIL);
        }
        if (state.enabledCaptcha) {
          commonEventEmitter.emit(`captcha.remove`);
        }
      })
      .catch((error) => {
        console.log(error);
        enableAnswer(AnswerType.FAIL);
        if (state.enabledCaptcha) {
          commonEventEmitter.emit(`captcha.remove`);
        }
      });
    }
  };

  const onSubmitButtonClick = (evt) => {
    evt.preventDefault();

    hideAnswer(AnswerType.SUCCESS, answerElement.querySelector(`.js-succes`));

    submitButton.removeEventListener(`click`, onSubmitButtonClick);
  };

  const addFilesFormData = (files, formData) => {
    files.map((file, index) => {
      formData.append(`file${index + 1}`, file);
    });
  };

  if (state.enabledCaptcha) {
    commonEventEmitter.on(`captcha.get`, onCaptchaGet);
    commonEventEmitter.on(`captcha.remove`, onCaptchaRemove);
  }

  form.addEventListener(`submit`, (evt) => {
    evt.preventDefault();

    post();
  });
};

export default post;
